import {
  GET_EVENTS_FAIL,
  GET_EVENTS_REQUEST,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_CANCEL,
  REMOVE_EVENT,
  UPDATE_EVENT,
} from '../actions/events';

const initialState = {
  events: [],
  eventsTotal: 0,
  eventsAllTotal: 0,
  eventsActiveTotal: 0,
  eventsBlockedTotal: 0,
  eventsSearchInfo: null,
  eventsLoading: false,
  eventsError: false,
  eventsErrorMessage: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_EVENTS_REQUEST: {
      return {
        ...state,
        eventsLoading: true,
        eventsError: false,
        eventsErrorMessage: '',
      };
    }
    case GET_EVENTS_SUCCESS: {
      const {
        events, total, total_active: totalActive, total_blocked: totalBlocked, search,
      } = action.payload;
      // Счётчики считаются по уже отфильтрованной выборке, поэтому обновляются при каждом ответе.
      const hasCounters = Number.isFinite(totalActive) && Number.isFinite(totalBlocked);

      return {
        ...state,
        events: events || [],
        eventsTotal: total || 0,
        eventsAllTotal: hasCounters ? totalActive + totalBlocked : state.eventsAllTotal,
        eventsActiveTotal: hasCounters ? totalActive : state.eventsActiveTotal,
        eventsBlockedTotal: hasCounters ? totalBlocked : state.eventsBlockedTotal,
        eventsSearchInfo: search || null,
        eventsLoading: false,
        eventsError: false,
        eventsErrorMessage: '',
      };
    }
    case GET_EVENTS_FAIL: {
      return {
        ...state,
        eventsLoading: false,
        eventsError: true,
        eventsErrorMessage: action.payload || 'Не удалось загрузить мероприятия',
      };
    }
    case GET_EVENTS_CANCEL: {
      return {
        ...state,
        eventsLoading: false,
        eventsError: false,
      };
    }
    case UPDATE_EVENT: {
      const newEvents = state.events.map(
        (item) => (item._id === action.payload._id ? Object.assign(item, action.payload) : item),
      );
      return {
        ...state,
        eventsLoading: false,
        eventsError: true,
        events: newEvents,
      };
    }
    case REMOVE_EVENT: {
      const newEvents = state.events.filter((item) => item._id !== action.payload._id);
      return {
        ...state,
        eventsLoading: false,
        eventsError: true,
        events: newEvents,
      };
    }

    default: {
      return state;
    }
  }
}
